import { logger } from '@nanostores/logger'
import { useStore } from '@nanostores/react'
import { atom } from 'nanostores'

import type { Filter, GetProps, MailboxFilter } from '../model/types'

import { useSettings } from './useSettings'

const $filter = atom<'' | Filter>(''),
	$mailboxFilter = atom<'' | MailboxFilter>(''),
	$search = atom(''),
	$searchDraft = atom('')
const tabFilters = new Set<Filter>(['focused', 'other'])

function useFilter(): Filter {
	const filter = useStore($filter)
	const { currentData } = useSettings()

	const isDefaultFilterChosen = filter === ''
	if (isDefaultFilterChosen) {
		return currentData?.focusedInboxEnabled ? 'focused' : 'primary'
	}

	return filter
}

function useGetProps(): GetProps {
	const filter = useFilter(),
		mailboxFilter = useStore($mailboxFilter),
	  search = useStore($search),
		searchDraft = useStore($searchDraft)

	return {
		filter,
		mailboxFilter,
		search,
		searchDraft
	}
}

function useShowTabs() {
	const { filter, search } = useGetProps()
	return !search && tabFilters.has(filter)
}

if (import.meta.env.DEV) {
	logger({
		$filter,
		$mailboxFilter,
		$search,
		$searchDraft
	})
}

export { $filter, $mailboxFilter, $search, $searchDraft, useFilter, useGetProps, useShowTabs }
